<template>
  <div class="green-operation__status">
    <div class="green-operation__status-info row align-center">
      <div class="small-12">
        <label>{{ $t('tenancy.greenOperation.status') }}</label>
        <div v-if="!isStarted">
          {{ currentStatus }}
        </div>
        <HKLStatusBadge
          v-else
          class="green-operation__status-value pointer"
          :value="currentStatus | uppercase"
          @click="openLifecycle"
        />
      </div>
    </div>
    <HKLGrayHint
      v-if="!isStarted && isTenant"
      class="tenant-hint font-size-14"
    >
      {{ $t('tenancy.greenOperation.sustainabilityHint') }}
    </HKLGrayHint>
    <GreenOperationStatusLifecycle
      ref="modal"
      :isSpp="true"
      :status="status"
    />
  </div>
</template>

<script>
import { computed, unref } from 'vue-demi'
import HKLStatusBadge from '@/controls/Badge/HKLStatusBadge.vue'
import HKLGrayHint from '@/controls/HKLGrayHint.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreGetters } from '@/store/index'
import GreenOperationStatusLifecycle from './GreenOperationStatusLifecycle.vue'
import { useGreenOperationSppStatus } from './GreenOperationSpp.hook'

export default {
  components: {
    HKLGrayHint,
    HKLStatusBadge,
    GreenOperationStatusLifecycle,
  },
  setup () {
    const userStore = useStoreGetters('user', ['isTenant'])
    const { status, statusDisplay, isStarted } = useGreenOperationSppStatus()
    const { open, modal } = useRefModal()
    return {
      ...userStore,
      modal,
      status,
      statusDisplay,
      isStarted,
      currentStatus: computed(() => {
        return unref(statusDisplay)
      }),
      openLifecycle: () => {
        if (!unref(isStarted)) return false
        open()
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.green-operation__status {
  &-info {
    margin-bottom: 30px;
    width: 100%;
    background-color: #F2F6F8;
    padding: 15px;

    label {
      margin-top: 0;
    }
  }
  &-value {
    display: inline-block;
  }
  .tenant-hint {
    margin-bottom: 20px;
  }
}
</style>
